import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { config } from '../env';
import { ClaimsCard } from './ClaimsCard';
import { NavRail } from './NavRail';
import { TopBar } from './TopBar';

/**
 * The persistent frame every surface renders inside: rail, top bar, surface
 * area, copyright footer. Layout and class names follow docs/clm-ui-mock.html; the
 * brand logo is rendered once, in the rail.
 */
export function AppShell() {
  const [claimsOpen, setClaimsOpen] = useState(false);

  return (
    <div className="pg">
      <a className="skip" href="#surface">
        Skip to content
      </a>

      {config.app_env !== 'prod' ? (
        <p className="envban">
          {config.app_env.toUpperCase()} environment — data here is not the contract record of
          truth.
        </p>
      ) : null}

      <div className="app">
        <NavRail />

        <div className="main">
          <TopBar claimsOpen={claimsOpen} onToggleClaims={() => setClaimsOpen((open) => !open)} />

          <div className="wrap" id="surface">
            {claimsOpen ? <ClaimsCard /> : null}
            <Outlet />
          </div>
        </div>
      </div>

      {/* The brand lockup lives in the rail (NavRail) and nowhere else. The footer
          used to repeat the logo — two cloudEQ marks on one screen, overlapping on
          narrow layouts — and Gerry asked for one (9 Sep 2026). Copyright line only. */}
      <footer className="bfoot">
        <p>cloudEQ | Proprietary and Confidential © 2026 cloudEQ, Inc</p>
      </footer>
    </div>
  );
}
